import constate from "constate";

const [Provider, useInsightsData, useInsightsDispatch] = constate(
  (values) => values,
  (value) => value.strategyInsights,
  (value) => value.insightsDispatch
);

export { Provider, useInsightsData, useInsightsDispatch };
